import { SOURCES } from './sources';
import './SourcesList.css';

export function SourcesList() {
  return (
    <ol className="SourcesList">
      {SOURCES.map((s, i) => (
        <li className="SourcesList-item" key={s.id} id={`source-${i + 1}`}>
          <a className="SourcesList-link" href={s.url} target="_blank" rel="noopener noreferrer">
            {s.title}
          </a>
          <span className="SourcesList-publisher">{s.publisher}</span>
          {s.note && <p className="SourcesList-note">{s.note}</p>}
        </li>
      ))}
    </ol>
  );
}
